"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.on = void 0;
function on(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}
exports.on = on;



//////////////////
// WEBPACK FOOTER
// ./~/socket.io-client/build/on.js
// module id = 1506
// module chunks = 2